import { Column } from 'react-table';
import { Popup } from 'semantic-ui-react';

import { SpeakingMonitoring, SpeakingMonitoringReason } from 'api';
import { formatDate } from 'utils';
import { CheckIcon, ViewDetailsButton } from 'components';
import { getSpeakingMonitoringStageName } from 'const/speaking-monitoring-stage/speakingMonitoringStageHelpers';
import { getSpeakingMonitoringReasonName } from 'const/speaking-monitoring-reason/speakingMonitoringReasonHelpers';
import { getSpeakingMonitoringResultName } from 'const/speaking-monitoring-result/speakingMonitoringResultHelpers';

export const columns: Column<SpeakingMonitoring>[] = [
  {
    Header: 'Date of Certification',
    accessor: 'certificationDate',
    width: 'auto',
    Cell: ({ value }) => <>{formatDate(value)}</>,
  },
  {
    Header: 'Date of monitoring',
    accessor: 'monitoringDate',
    width: 'auto',
    Cell: ({ value }) => <>{formatDate(value)}</>,
  },
  {
    Header: 'Final result',
    accessor: 'finalResult',
    width: 'auto',
    Cell: ({ value }) => <>{getSpeakingMonitoringResultName(value)}</>,
  },
  {
    Header: 'Monitoring stage',
    accessor: 'monitoringStage',
    width: 'auto',
    Cell: ({ value }) => <>{getSpeakingMonitoringStageName(value)}</>,
  },
  {
    Header: 'IDP',
    accessor: 'isFromIdp',
    width: '50px',
    Cell: CheckIcon,
  },
  {
    Header: 'Procedures result',
    accessor: 'proceduresResult',
    width: 'auto',
    Cell: ({ value }) => <>{value ? getSpeakingMonitoringResultName(value) : ''}</>,
  },
  {
    Header: 'Rating result',
    accessor: 'ratingResult',
    width: 'auto',
    Cell: ({ value }) => <>{value ? getSpeakingMonitoringResultName(value) : ''}</>,
  },
  {
    Header: 'Type of monitoring',
    accessor: 'reason',
    width: 'auto',
    Cell: ({ row }) => (
      <Popup
        disabled={row.original.reason !== SpeakingMonitoringReason.Other}
        trigger={
          <span>
            {row.original.reason ? getSpeakingMonitoringReasonName(row.original.reason) : ''}
          </span>
        }
        content="For more information use details button"
        position="top center"
      />
    ),
  },
  {
    Header: 'Follow Up completed',
    accessor: 'followUpId',
    width: '75px',
    Cell: CheckIcon,
  },
  {
    Header: 'Details',
    accessor: 'id',
    width: '50px',
    Cell: ({ value }) => <ViewDetailsButton to={value} />,
  },
];
